module.exports = __webpack_public_path__ + "img/square-exclamation.2c267189.svg";